var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignedCandidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Aligned",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13016",
    "data-name": "Path 13016",
    d: "M77.668,8a8,8,0,1,1-8-8,8,8,0,0,1,8,8",
    transform: "translate(-61.668)",
    fill: "#00c22d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13017",
    "data-name": "Path 13017",
    d: "M74.739,5.562,73.387,4.343,67.978,9.219,65.95,7.39,64.6,8.609l2.029,1.828h0l1.353,1.219,1.353-1.219Z",
    transform: "translate(-61.668)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignedCandidate);
export default __webpack_public_path__ + "static/media/Aligned-candidate.30288c1f262d6faa0dc7b4cee32ab270.svg";
export { ForwardRef as ReactComponent };